/**
 * 课程服务
 * 处理课程相关的 API 调用
 */

import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * 课程服务
 */
const courseService = {
  /**
   * 获取课程列表（分页）
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.per_page - 每页数量
   * @param {string} params.name - 课程名筛选
   * @param {string} params.teacher - 教师筛选
   * @param {string} params.status - 状态筛选
   * @returns {Promise<Object>}
   */
  async getList(params = {}) {
    return apiClient.get(API_ENDPOINTS.COURSES.LIST, {
      page: 1,
      per_page: 20,
      ...params,
    });
  },

  /**
   * 获取课程名称列表（不分页，用于下拉选择）
   * @returns {Promise<Array>}
   */
  async getNameList() {
    return apiClient.get(API_ENDPOINTS.COURSES.NAMES);
  },

  /**
   * 获取课程详情
   * @param {number} id - 课程 ID
   * @returns {Promise<Object>}
   */
  async getById(id) {
    return apiClient.get(API_ENDPOINTS.COURSES.DETAIL(id));
  },

  /**
   * 创建课程
   * @param {Object} data - 课程数据
   * @returns {Promise<Object>}
   */
  async create(data) {
    return apiClient.post(API_ENDPOINTS.COURSES.CREATE, data);
  },

  /**
   * 更新课程
   * @param {number} id - 课程 ID
   * @param {Object} data - 更新数据
   * @returns {Promise<Object>}
   */
  async update(id, data) {
    return apiClient.put(API_ENDPOINTS.COURSES.UPDATE(id), data);
  },

  /**
   * 删除课程
   * @param {number} id - 课程 ID
   * @returns {Promise<Object>}
   */
  async delete(id) {
    return apiClient.delete(API_ENDPOINTS.COURSES.DELETE(id));
  },
};

export default courseService;
